import { Button, Select } from "@mantine/core";
import { Send } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import {
    AutoHeightContainer,
    GlobalInviteView,
    PageHeader,
    PriorityInviteView,
    usePageSearch,
    useTherapproveModals
} from "@therapprove/common";
import { useState } from "react";

const INVITE_VIEWS = [
    { value: "clinic", label: "Clinic Invites" },
    { value: "global", label: "Global Invites" }
];

export const PriorityInvites = () => {
    // State
    const { priorityPublicInvite } = useTherapproveModals();
    const { search, setSearch, debouncedSearch } = usePageSearch();
    const [activeView, setActiveView] = useState(() => {
        const hash = window.location.hash.replace("#", "");
        return hash === "global" ? "global" : "clinic";
    });

    const handleViewChange = (value: string | null) => {
        const view = value ?? "clinic";
        setActiveView(view);
        window.location.hash = view;
    };

    return (
        <AutoHeightContainer style={{ gap: "0.5rem" }}>
            <PageHeader
                search={search}
                setSearch={setSearch}
                placeholder="Search invites..."
                leftSection={
                    <Select
                        data={INVITE_VIEWS}
                        value={activeView}
                        onChange={handleViewChange}
                        allowDeselect={false}
                        style={{ width: 170 }}
                    />
                }
                rightSection={
                    <Button
                        leftSection={<SvgIcon component={Send} />}
                        onClick={() => priorityPublicInvite.open()}
                    >
                        Invite Client
                    </Button>
                }
            />
            {activeView === "clinic" ? (
                <PriorityInviteView
                    search={debouncedSearch}
                    onModalOpen={() => priorityPublicInvite.open()}
                />
            ) : (
                <GlobalInviteView search={debouncedSearch} />
            )}
        </AutoHeightContainer>
    );
};
